import { GrLogout } from 'react-icons/gr';
import { Button } from '../ui/button';
import { useMixpanel } from '@/lib/misc/mixpanel';
import { useSession } from '@/contexts/LitSessionProvider';
import { useTurnKeyAuth } from '@/hooks/auth/turnkey/useTurnKeyAuth';
export default function LogoutBtn() {
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const {
    PKP,
    clearLitSession
  } = useSession();
  const {
    logoutTurnKey
  } = useTurnKeyAuth();
  return <div className='w-full py-2 px-4' data-sentry-component="LogoutBtn" data-sentry-source-file="LogoutBtn.tsx">
      <Button onClick={async () => {
      LogToMixpanel({
        pkp: PKP,
        eventName: EVENTS.auth.signout,
        category: CATEGORIES.auth
      });
      await logoutTurnKey();
      clearLitSession();
      window.location.href = '/home?message=You have been signed out';
    }} className='text-genius-cream rounded-full w-full mx-auto py-2 h-14 bg-genius-blue md:hover:bg-genius-blue' data-sentry-element="Button" data-sentry-source-file="LogoutBtn.tsx">
        <GrLogout className='h-4 w-4 mr-4' data-sentry-element="GrLogout" data-sentry-source-file="LogoutBtn.tsx" />
        Log Out
      </Button>
    </div>;
}